import { getImagePreloadCandidates } from "../components/imageMeta";

export const CHECKOUT_HERO_IMAGE_URL = "/cooky/Collateral/funnel-checkout.avif";

export const CHECKOUT_FEATURE_IMAGE_URLS = {
  dailyDrops: "/cooky/mascot/mascot-quick-meals.webp",
  curiosityHabit: "/cooky/mascot/mascot-saving-money.webp",
  personalized: "/cooky/mascot/mascot-family-meals.webp",
  rewarding: "/cooky/mascot/mascot-eating-healthy.webp"
} as const;

const CHECKOUT_IMAGE_URLS = [CHECKOUT_HERO_IMAGE_URL, ...Object.values(CHECKOUT_FEATURE_IMAGE_URLS)];

export const getCheckoutImagePreloadUrls = (): string[] => {
  const uniqueUrls = new Set<string>();

  for (const imageUrl of CHECKOUT_IMAGE_URLS) {
    const candidates = getImagePreloadCandidates(imageUrl);
    for (const candidate of candidates) {
      uniqueUrls.add(candidate);
    }
  }

  return Array.from(uniqueUrls);
};
